<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Bubble" });
import "tailwindcss/tailwind.css";
import Icon from "../icon/Icon.svelte";
export let color = "light";
export let position = "north";
export let isVisible = true;
export let css = "";
const closeBubble = () => {
    isVisible = false;
};
$: classes = `s8-bubble s8-${color} ${css}`;
</script>

{#if isVisible }
    <div data-position = { position } class = { classes }>
        <Icon key = 'close' on:click = { closeBubble } css = 'w-5 absolute right-2 top-2 z-20' />
        <slot>Hello World</slot>
    </div>
{/if}

<style>

    div.s8-bubble {

        position: absolute;

        z-index: 10;

        border-radius: 0.5rem;

        padding: 1.5rem;

        line-height: 1.5;

        --tw-shadow: 0px 2px 15px 0px rgba(39, 39, 17, 0.10);;

        --tw-shadow-colored: 0px 2px 15px 0px var(--tw-shadow-color);

        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

        transition-property: opacity;

        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

        transition-duration: 150ms;

        --offset: 20px;
}

        div.s8-bubble:after {

        position: absolute;

        height: 0.75rem;

        width: 0.75rem;

        border-top-left-radius: 0.25rem;

        background-color: inherit;
            content: '';
            clip-path: polygon(100% 0, 0% 100%, 0 0);
}

        /* Positions & Arrows --------------------------------------- */

        /* north, north-east, north-west */

        div.s8-bubble[data-position^='north'] {
            /* move anything starting with north to the top */
            bottom: calc(100% + var(--offset) / 2);
        }

        div.s8-bubble[data-position^='north']:after {

        bottom: -0.375rem;

        --tw-rotate: 225deg;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* south, south-east, south-west */

        div.s8-bubble[data-position^='south'] {
            /* move anything starting with south to the bottom */
            top: calc(100% + var(--offset) / 2);
        }

        div.s8-bubble[data-position^='south']:after {

        top: -0.375rem;

        --tw-rotate: 45deg;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* west, west-north, west-south */

        div.s8-bubble[data-position^='west'] {
            /* move anything starting with west to the left */
            right: calc(100% + var(--offset) / 2);
        }

        div.s8-bubble[data-position^='west']:after {

        right: -0.375rem;

        --tw-rotate: 135deg;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* east, east-north, east-south */

        div.s8-bubble[data-position^='east'] {
            /* move anything starting with east to the right */
            left: calc(100% + var(--offset) / 2);
        }

        div.s8-bubble[data-position^='east']:after {

        left: -0.375rem;

        --tw-rotate: 315deg;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* north & south */

        div.s8-bubble[data-position='north'],
        div.s8-bubble[data-position='south'] {

        left: 50%;

        --tw-translate-x: -50%;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        div.s8-bubble[data-position='north']:after, div.s8-bubble[data-position='south']:after {

        left: 50%;

        --tw-translate-x: -50%;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* east & west */

        div.s8-bubble[data-position='west'],
        div.s8-bubble[data-position='east'] {

        top: 50%;

        --tw-translate-y: -50%;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        div.s8-bubble[data-position='west']:after, div.s8-bubble[data-position='east']:after {

        top: 50%;

        --tw-translate-y: -50%;

        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

        /* east-south & west-south */

        div.s8-bubble[data-position$='-south'] {

        bottom: 0px;
}

        /* move anything ending with south to the bottom */

        div.s8-bubble[data-position$='-south']:after {

        top: 1.5rem;
}

        /* north-west & south-west */

        div.s8-bubble[data-position$='-west'] {

        left: 0px;
}

        /* move anything ending with west to the right */

        div.s8-bubble[data-position$='-west']:after {

        left: 1.5rem;
}

        /* north-east & south-east */

        div.s8-bubble[data-position$='-east'] {

        right: 0px;
}

        /* move anything ending with east to the left */

        div.s8-bubble[data-position$='-east']:after {

        right: 1.5rem;
}

        /* east-north & west-north */

        div.s8-bubble[data-position$='-north'] {

        top: 0px;
}

        /* move anything ending with east to the top */

        div.s8-bubble[data-position$='-north']:after {

        bottom: 1.5rem;
}

        /* Styles --------------------------------------------------- */

        div.s8-bubble.s8-light {

        border-color: rgba(255, 255, 255, 1);

        background-color: rgba(255, 255, 255, 1);

        --tw-text-opacity: 1;

        color: rgb(0 0 0 / var(--tw-text-opacity));

        --tw-shadow: 0px 2px 15px 0px rgba(39, 39, 17, 0.10);;

        --tw-shadow-colored: 0px 2px 15px 0px var(--tw-shadow-color);

        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

        div.s8-bubble.s8-secondary {

        border-color: rgba(193, 122, 103, 1);

        background-color: rgba(193, 122, 103, 1);

        color: rgba(255, 255, 255, 1);
}</style>